// extracted by mini-css-extract-plugin
module.exports = {"errorWrapper":"Courses__error-wrapper","errorTitle":"Courses__error-title","errorText":"Courses__error-text"};